import Loading from "./Loading";

/**
 * 데이터 로딩 표시 블록(성과 보드 공통, 2026-08-05).
 *
 * 왜 필요한가: 성과 보드 하위 화면들은 조회 중에도 **빈 표를 그대로 보여줬다.**
 * 그래서 "데이터가 없는 것"인지 "아직 불러오는 중"인지 구분할 수 없었다(특히 기간을 길게 잡아 느릴 때).
 *
 * 실패했을 때 `error` 를 주면 사유를 보여준다 — 실패까지 빈 화면으로 두면 같은 혼동이 반복된다.
 *
 * `title`·`tone` 은 실패 머리말과 색을 바꾼다(2026-09-11, 결정항목 D-8).
 * 외부 연동 서비스의 일시 장애처럼 **사용자가 할 수 있는 일이 기다리는 것뿐인** 경우에는
 * 붉은 "데이터를 불러오지 못했습니다" 가 서비스가 깨진 것처럼 읽힌다. 그런 자리에만
 * `tone="notice"` 로 낮춘다. 🔴 **기본값은 종전과 같다**(붉은 오류) — 이미 쓰고 있는
 * 화면들의 실패는 실제로 우리 쪽 오류이고, 거기서 색이 빠지면 눈에 안 띈다.
 */
const LoadingBlock = ({
  text = "데이터를 불러오는 중입니다…",
  error = "",
  title = "데이터를 불러오지 못했습니다.",
  tone = "error",
}) => {
  if (error) {
    return (
      <div className="w-full flex flex-col items-center justify-center gap-2 py-16">
        <div className={`text-sm font-semibold ${tone === "notice" ? "text-gray-700" : "text-red-600"}`}>{title}</div>
        <div className="text-xs text-gray-500 text-center px-4 break-words">{error}</div>
        <div className="text-xs text-gray-400">잠시 후 다시 시도하거나 조회 기간을 좁혀 주세요.</div>
      </div>
    );
  }
  return (
    <div className="w-full flex flex-col items-center justify-center gap-3 py-16">
      <Loading className="w-12 h-12" />
      <div className="text-sm text-gray-500">{text}</div>
    </div>
  );
};

export default LoadingBlock;
